<template>
  <div class="orderPage">
    <el-card class="box-card">
      <div slot="header">
        <CardHeader
          title="基础信息"
          settleType="all"
          :buttons="topBtns"
          :turnType="turnType"
          :currStatus="currStatus"
          @save="save"
          @oneClickRelease="oneClickRelease"
          @oneClickReleaseAndRefresh="oneClickReleaseAndRefresh"
          @cancel="cancel"
          @invalid="invalid"
          @handleSettleStatus="handleSettleStatus"
        />
      </div>
      <!-- 产品信息 -->
      <BaseDataInfo
        ref="baseDataRef"
        @contractChange="contractChange"
        :turnType="turnType"
        :baseDataDetailInfo="baseDataDetailInfo"
        :currStatus="currStatus"
      />
    </el-card>
    <el-card class="box-card" v-if="turnType === '3'" style="margin-top: 10px">
      <div slot="header">
        <CardHeader title="结算信息" />
      </div>
      <SettlementInfo :settlementInfo="settlementInfo" :turnType="turnType" />
    </el-card>
    <el-card class="box-card" v-if="turnType === '3'" style="margin-top: 10px">
      <div slot="header">
        <CardHeader title="订单可视化信息" />
      </div>
      <OrderProgress :currStatus="currStatus" :listData="infoArr" />
    </el-card>
    <!-- 产品与服务信息 -->
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header">
        <CardHeader title="产品与服务信息" />
      </div>
      <ProductInfo
        ref="productInfoRef"
        :highwayTypeList="highwayTypeList"
        :railwayTypeList="railwayTypeList"
        :turnType="turnType"
        :currStatus="currStatus"
        @handleCheckedRailway="handleCheckedRailway"
        @handleCheckedHighway="handleCheckedHighway"
      />
    </el-card>
    <!-- 普通运输服务 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('0')">
      <div slot="header">
        <CardHeader
          title="普通公路运输"
          settleType="0"
          :buttons="turnType === '1' ? detailBtn : issuedBtn"
          @issued="issued('0')"
          @instructionInvalid="instructionInvalid('0')"
          @batchIssued="batchIssued('0')"
          @handleSettleStatus="handleSettleStatus"
          :turnType="turnType"
          typeCard="0"
          :currStatus="currStatus"
        />
      </div>
      <TransportService
        :contractRelationInfo="contractRelationInfo"
        :highwayArr="highwayArr"
        :turnType="turnType"
        type="general"
        ref="transTable"
        :transCurrStatus="highCurrStatus"
        :baseData="baseDataDetailInfo"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 集卡运输服务 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('1')">
      <div slot="header">
        <CardHeader
          title="集卡运输服务"
          settleType="1"
          :buttons="turnType === '1' ? detailBtn : issuedBtn"
          @issued="issued('1')"
          @instructionInvalid="instructionInvalid('1')"
          @batchIssued="batchIssued('1')"
          :turnType="turnType"
          typeCard="1"
          :currStatus="currStatus"
          @handleSettleStatus="handleSettleStatus"
        />
      </div>
      <TransportService
        type="truck"
        :contractRelationInfo="contractRelationInfo"
        ref="truckTable"
        :collectArr="collectArr"
        :turnType="turnType"
        :transCurrStatus="jikaCurrStatus"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 公路装卸服务 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('2')">
      <div slot="header">
        <CardHeader
          settleType="2"
          title="公路装卸服务"
          :buttons="issuedBtn"
          @issued="issued('2')"
          :turnType="turnType"
          :currStatus="currStatus"
          @handleSettleStatus="handleSettleStatus"
        />
      </div>
      <CommonService
        ref="handlingService"
        :contractRelationInfo="contractRelationInfo || {}"
        :commonServiceArr="highwayLoading"
        :turnType="turnType"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 咨询服务信息 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('3')">
      <div slot="header">
        <CardHeader
          settleType="3"
          title="咨询服务"
          :buttons="issuedBtn"
          :turnType="turnType"
          :currStatus="currStatus"
          @handleSettleStatus="handleSettleStatus"
          @issued="issued('3')"
        />
      </div>
      <CommonService
        ref="consultingService"
        :contractRelationInfo="contractRelationInfo || {}"
        :turnType="turnType"
        :commonServiceArr="consultArr"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 仓储服务信息 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('4')">
      <div slot="header">
        <CardHeader
          settleType="4"
          title="仓储服务"
          :turnType="turnType"
          @handleSettleStatus="handleSettleStatus"
          :currStatus="currStatus"
          :buttons="issuedBtn"
          @issued="issued('4')"
        />
      </div>
      <CommonService
        ref="warehousingService"
        :contractRelationInfo="contractRelationInfo || {}"
        :commonServiceArr="storageArr"
        :turnType="turnType"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 监管服务信息 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedHighList.includes('5')">
      <div slot="header">
        <CardHeader
          settleType="5"
          title="监管服务"
          :turnType="turnType"
          :currStatus="currStatus"
          :buttons="issuedBtn"
          @handleSettleStatus="handleSettleStatus"
          @issued="issued('5')"
        />
      </div>
      <CommonService
        ref="superviseService"
        :contractRelationInfo="contractRelationInfo || {}"
        :commonServiceArr="superviseArr"
        :turnType="turnType"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 铁路运输代理服务 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedRailList.includes('6')">
      <div slot="header">
        <CardHeader
          settleType="6"
          title="铁路运输代理服务"
          :turnType="turnType"
          :buttons="turnType === '1' ? transportDetailBtn : issuedBtn"
          :currStatus="currStatus"
          @instructionInvalid="instructionInvalid('6')"
          @handleSettleStatus="handleSettleStatus"
          @issued="issued('6')"
        />
      </div>
      <AgencyService
        ref="agencyService"
        :contractRelationInfo="contractRelationInfo || {}"
        :turnType="turnType"
        :transAgencyArr="transAgencyArr"
        :baseData="baseDataDetailInfo"
        :currStatus="currStatus"
        :checkedRailList="checkedRailList"
      />
    </el-card>
    <!-- 铁路装卸服务 -->
    <el-card class="box-card" style="margin-top: 10px" v-show="checkedRailList.includes('7')">
      <div slot="header">
        <CardHeader
          settleType="7"
          title="铁路装卸服务"
          :turnType="turnType"
          @handleSettleStatus="handleSettleStatus"
          :buttons="issuedBtn"
          :currStatus="currStatus"
          @issued="issued('7')"
        />
      </div>
      <CommonService
        ref="dockService"
        :contractRelationInfo="contractRelationInfo || {}"
        :turnType="turnType"
        :commonServiceArr="railwayLoadingArr"
        :currStatus="currStatus"
      />
    </el-card>
    <!-- 附件 -->
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header">
        <CardHeader title="附件上传" />
      </div>
      <div>
        <FileTable
          ref="fileTableRef"
          :attachments="storageAttachment"
          :isDisabledDelete="turnType === '3'"
          :isDisabledUpload="turnType === '3'"
          :isShowDownBtn="turnType === '3' && baseDataDetailInfo?.lopOrderCode == null"
          :showLinks="baseDataDetailInfo?.lopOrderCode?.length != 0"
          :cellClick="attachmentCellClick"
          :cellStyle="attachmentCellStyle"
        />
      </div>
    </el-card>
    <!-- 异常维护 -->
    <el-card class="box-card" style="margin-top: 10px" v-if="turnType === '3'">
      <div slot="header">
        <CardHeader title="异常维护" />
      </div>
      <AbnormalMaintain :exceptions="exceptions" @refresh="refresh" />
    </el-card>
    <SettleDialog
      v-if="settleDialogVisible"
      :settleDialogTitle="settleDialogTitle"
      :settleDialogVisible="settleDialogVisible"
      :dialogData="dialogData"
      :dialogType="dialogType"
      @settleDialogClose="settleDialogClose"
    />
  </div>
</template>

<script>
  import { headerBtns, detailHeaderBtns } from './data';
  import CardHeader from './component/cardHeader';
  import BaseDataInfo from './component/baseDataInfo';
  import ProductInfo from './component/productInfo';
  import TransportService from './component/transportService';
  import CommonService from './component/commonService';
  import AgencyService from './component/agencyService';
  import SettlementInfo from './component/settlementInfo';
  import AbnormalMaintain from './component/abnormalMaintain';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import API from '@/api/intermodality/order';
  import { mapState } from 'vuex';
  import SettleDialog from './component/settleDialog';
  import OrderProgress from './component/orderProgress';
  import XEUtils from 'xe-utils';
  import { instructStatusList } from './data';
  export default {
    name: 'orderPage',
    mixins: [orderMixin],
    components: {
      CardHeader,
      BaseDataInfo,
      ProductInfo,
      TransportService,
      CommonService,
      AgencyService,
      SettlementInfo,
      AbnormalMaintain,
      SettleDialog,
      OrderProgress,
    },
    data() {
      return {
        headerBtns,
        detailHeaderBtns,
        baseDataRules: {},
        storageAttachment: [], // 附件
        checkedHighList: [], // 已选择的公路服务
        checkedRailList: [], // 已选择的铁路服务
        issuedBtn: [
          {
            name: '下发',
            type: 'primary',
            changeMethod: 'issued',
          },
        ],
        detailBtn: [
          {
            name: '批量下发',
            type: 'primary',
            changeMethod: 'batchIssued',
          },
          {
            name: '作废',
            type: 'primary',
            changeMethod: 'instructionInvalid',
          },
        ],
        transportDetailBtn: [
          {
            name: '下发',
            type: 'primary',
            changeMethod: 'issued',
          },
          {
            name: '作废',
            type: 'primary',
            changeMethod: 'instructionInvalid',
          },
        ],
        contractRelationInfo: {}, //合同相关的信息
        baseDataDetailInfo: {},
        settlementInfo: {},
        highwayTypeList: [], // 公路复选框已选
        railwayTypeList: [], //铁路复选框已选
        highwayArr: [], // 普通运输服务
        collectArr: [], //集卡运输详情
        highwayLoading: [], // 公路装卸
        consultArr: [], // 咨询服务
        storageArr: [], // 仓储服务
        superviseArr: [], // 监管
        railwayLoadingArr: [], //铁路装卸
        transAgencyArr: [], // 铁路运输代理
        exceptions: [],
        contractHighway: [],
        contractRailWay: [],
        highCurrStatus: '',
        jikaCurrStatus: '',
        transportInstructsList: [],
        ordinaryTruckInstructsList: [],
        settleDialogTitle: '',
        settleDialogVisible: false,
        dialogType: '',
        dialogData: [],
        infoArr: [],
        instructStatusList,
        serviceList: [],
        isCopy: 1,
        copyParams: {},
        detailId: '',
        detailCode: '',
        copyDetailId: '',
        copyDetailCode: '',
        detailTransportInstructs: [],
        copyTransportInstructs: [],
        detailOrderStatus: '',
        containerTypeList: [], // 编辑时获取箱型列表
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 0为新增 1为编辑 2为复制 3 为查看详情
      turnType() {
        return this.$route.query.turnType;
      },
      currStatus() {
        return this.$route.query.orderCurrStatus;
      },
      orderId() {
        return this.$route.query.id;
      },
      commonShowFlag() {
        return (
          this.contractRelationInfo.saleDepartmentName ||
          this.turnType === '3' ||
          this.turnType === '1' ||
          this.turnType === '2'
        );
      },
      topBtns() {
        if (this.turnType === '1') {
          return this.detailHeaderBtns;
        } else {
          return this.headerBtns;
        }
      },
    },
    created() {
      this.getServiceList();
      this.initDicData();
      if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
        // 查看详情 或 编辑
        this.getOrderDetail(this.orderId);
      }
    },
    methods: {
      attachmentCellClick(val) {
        if (val.column?.property == 'attachmentName') {
          let path = val.row.attachmentPath;
          window.open(path, '_blank');
        }
      },
      attachmentCellStyle({ column }) {
        if (column.property == 'attachmentName') {
          return {
            color: '#009fcc',
          };
        }
      },
      // 查看订单结算状态
      handleSettleStatus(val) {
        console.log(val, '1111111111');
        if (val === 'all') {
          // 查看订单状态
          const orderCodeList = [this.$route.query.orderCode];
          const params = {
            orderCodes: orderCodeList,
            instructionNos: [],
          };
          this.$axios.post(API.SETTLE_STATUS, params).then((res) => {
            if (res.data.code === 0) {
              this.settleDialogTitle = '订单结算状态';
              this.settleDialogVisible = true;
              this.dialogType = 'order';
              this.dialogData = res.data.data || [];
            }
          });
        } else {
          // 查看指令单结算状态
          const params = {
            orderCodes: [],
            instructionNos: [],
          };
          console.log(params, 'params');
          if (val === '0' || val === '1') {
            if (this.ordinaryTruckInstructsList.length > 0) {
              this.ordinaryTruckInstructsList.forEach((ordinary) => {
                if (ordinary.serviceType === val) {
                  params.instructionNos.push(ordinary.instructCode);
                }
              });
            }
          } else {
            if (this.transportInstructsList.length > 0) {
              this.transportInstructsList.forEach((trans) => {
                if (trans.serviceType === val) {
                  params.instructionNos.push(trans.instructCode);
                }
              });
            }
          }
          this.$axios.post(API.SETTLE_STATUS, params).then((res) => {
            if (res.data.code === 0) {
              this.settleDialogTitle = '指令结算状态';
              this.settleDialogVisible = true;
              this.dialogType = 'instruction';
              this.dialogData = res.data.data || [];
            }
          });
        }
      },
      // 订单作废
      invalid() {
        console.log('invalid');
        if (!this.orderId) return;
        // const ids = [this.orderId];
        const params = {
          id: this.orderId,
          // isInvalid: 1,
          orderCode: this.detailCode,
        };
        this.$axios.post(API.ORDER_INVALID, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        });
      },
      // 查看订单结算状态
      // settleStatus() {
      //   console.log('settleStatus');
      // },
      // 指令作废
      instructionInvalid(val) {
        console.log(val, '111111111');
        if (val === '0' || val === '1') {
          let ids = [];
          let selectedData = [];
          if (val === '0') {
            selectedData = this.$refs.transTable.selectGeneralList || [];
          } else if (val === '1') {
            selectedData = this.$refs.truckTable.selectTrunkList || [];
          }
          if (selectedData.length === 0) {
            return this.$message({
              showClose: true,
              message: '请选择数据',
              type: 'error',
            });
          }
          let hasInvalidStatus = false;
          selectedData.map((item) => {
            if (item.instructStatus === 'invalid') {
              hasInvalidStatus = true;
            }
          });
          if (hasInvalidStatus) {
            return this.$message({
              showClose: true,
              message: '选择的数据中有已作废的数据',
              type: 'error',
            });
          }
          selectedData.forEach((selected) => {
            if (selected.instructStatus !== 'invalid') {
              ids.push(selected.id);
            }
          });
          if (ids.length === 0) {
            return this.$message({
              showClose: true,
              message: '新增指令不允许立即作废',
              type: 'error',
            });
          }
          this.$confirm('指令单作废后将无法进行结算，是否确定要作废此指令单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              const params = {
                // isInvalid: 1,
                ids,
                orderCode: this.detailCode,
              };
              // params.ids = ids;
              this.loading.startLoading();
              this.$axios.post(API.ORDINARY_INVALID, params).then((res) => {
                console.log(res, '1111');
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.getOrderDetail(this.detailId);
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
            })
            .finally(() => this.loading.endLoading());
        } else {
          // let ids = [];
          // let selectedData = [];
          // selectedData = this.$refs.agencyService.agencyList || [];
          // if (selectedData.length === 0) {
          //   return this.$message({
          //     showClose: true,
          //     message: '请选择数据',
          //     type: 'error',
          //   });
          // }
          // let hasInvalidStatus = false;
          // selectedData.map((item) => {
          //   if (item.instructStatus === 'invalid') {
          //     hasInvalidStatus = true;
          //   }
          // });
          // if (hasInvalidStatus) {
          //   return this.$message({
          //     showClose: true,
          //     message: '选择的数据中有已作废的数据',
          //     type: 'error',
          //   });
          // }
          // selectedData.forEach((selected) => {
          //   if (selected.instructStatus !== 'invalid') {
          //     ids.push(selected.id);
          //   }
          // });
          // if (ids.length === 0) {
          //   return this.$message({
          //     showClose: true,
          //     message: '新增指令不允许立即作废',
          //     type: 'error',
          //   });
          // }
          this.$confirm('指令单作废后将无法进行结算，是否确定要作废此指令单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              const params = {
                // isInvalid: 1,
                ids: [this.$refs.agencyService.agencyServiceForm.id],
                orderCode: this.detailCode,
              };
              // params.ids = ids;
              this.loading.startLoading();
              this.$axios.post(API.TRANSPORT_INVALID, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.returnPath();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
            })
            .finally(() => this.loading.endLoading());
        }
      },
      // 指令批量下发
      batchIssued(val) {
        console.log(val, 'batchIssued');
        // let ids = [];
        let selectedData = [];
        let fullData = [];
        if (val === '0') {
          fullData = this.$refs.transTable.generalData || [];
          selectedData = this.$refs.transTable.getSelectedList() || [];
        } else {
          selectedData = this.$refs.truckTable.selectTrunkList || [];
          fullData = this.$refs.truckTable.getSelectedList() || [];
        }
        if (selectedData.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据',
            type: 'error',
          });
        }
        fullData.map((full) => {
          delete full.isOverdue;
          selectedData.map((selected) => {
            if (selected.id === full.id) {
              full.needToIssue = 1;
            }
          });
        });
        const params = {
          orderCode: this.detailCode,
          serviceType: val,
          ordinaryTruckInstructs: fullData,
        };
        // selectedData.forEach((selected) => {
        //   ids.push(selected.id);
        // });
        // const params = {
        //   ids: ids,
        // };
        this.loading.startLoading();
        this.$axios.post(API.BATCH_ISSUED, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getOrderDetail(this.detailId);
          }
        });
      },
      initDicData() {
        this.getContainerTypeList();
        this.getServiceList();
        // this.getUnitList();
      },
      refresh() {
        this.getOrderDetail(this.orderId);
      },
      async getOrderDetail(orderId) {
        const params = {
          id: orderId,
        };
        this.loading.startLoading();
        await this.$axios
          .post(API.ORDER_DETAIL, params)
          .then(async (res) => {
            if (res.data.code === 0) {
              if (this.turnType === '0' || (this.turnType === '2' && this.isCopy !== 1)) {
                // let newQuery = JSON.parse(JSON.stringify(this.$route.query));
                // newQuery.turnType === '1';
                const path = {
                  path: '/intermodality/orderPage',
                  name: 'orderPage',
                  meta: {
                    keepAlive: false,
                    title: '订单详情',
                  },
                  query: {
                    id: res.data.data.id,
                    orderCode: res.data.data.orderCode,
                    turnType: '1',
                    orderCurrStatus: res.data.data.orderStatus,
                  },
                };
                this.$router.push(path);
              }
              this.exceptions = [];
              const orderDetailData = res.data.data || {};
              if (this.turnType === '1') {
                // 编辑时获取箱型列表
                const arr = [];
                const containerType = JSON.parse(orderDetailData.containerTypeNum);
                containerType.forEach((item) => {
                  arr.push({
                    label: item.type,
                    value: item.type,
                  });
                });
                this.$nextTick(() => {
                  this.$refs.truckTable.containerTypeList = arr;
                });
                // this.containerTypeList = JSON.parse(orderDetailData.containerTypeNum);
              }
              this.detailId = orderDetailData.id;
              this.detailCode = orderDetailData.orderCode;
              this.detailTransportInstructs = orderDetailData.transportInstructs || [];
              this.detailOrderStatus = orderDetailData.orderStatus;
              this.copyParams = {
                id: orderDetailData.id,
                orderCode: orderDetailData.orderCode,
                orderCompletedDate: orderDetailData.orderCompletedDate,
                orderStatus: orderDetailData.orderStatus,
              };
              this.transportInstructsList = orderDetailData.transportInstructs || [];
              this.ordinaryTruckInstructsList = orderDetailData.ordinaryTruckInstructs || [];
              // this.orderDetail = orderDetailData || {};
              this.storageAttachment = orderDetailData.attachments || [];
              // 异常列表信息
              this.exceptions = orderDetailData.exceptions || [];

              // 处理基础信息
              await this.getBaseInfoData(orderDetailData);
              // 处理结算信息
              this.getSettlementInfoData(orderDetailData);
              // 可视化信息
              this.getViewInfo(orderDetailData);
              // 处理产品与服务信息
              this.getProductInfo(orderDetailData);
            }
          })
          .finally(() => {
            this.loading.endLoading();
            this.$nextTick(() => {
              this.contractRelationInfo = this.baseDataDetailInfo;
            });
          });
      },
      // 处理详情基础详情获得的数据
      getBaseInfoData(detailData) {
        const baseDataDetailInfo = {
          customerNo: detailData.customerNo,
          customerName: detailData.customerName,
          contractCode: detailData.contractCode,
          contractName: detailData.contractName,
          projectName: detailData.projectName,
          projectCode: detailData.projectCode,
          customerContactName: detailData.customerContactName,
          customerContactPhone: detailData.customerContactPhone,
          platformCompanyName: detailData.platformCompanyName,
          platformCompanyNo: detailData.platformCompanyNo,
          saleDepartmentName: detailData.saleDepartmentName,
          saleDepartmentNo: detailData.saleDepartmentNo,
          createDepartmentName: detailData.createDepartmentName,
          createDepartmentNo: detailData.createDepartmentNo,
          businessDepartmentName: detailData.businessDepartmentName,
          businessDepartmentCode: detailData.businessDepartmentCode,
          salesmanName: detailData.salesmanName,
          salesmanId: detailData.salesmanId,
          orderCreateDate: detailData.orderCreateDate || detailData.gmtCreate,
          orderCompletedDate: this.turnType === '2' ? '' : detailData.orderCompletedDate,
          orderCreatorName:
            this.turnType === '2' ? this.userInfo.personName : detailData.orderCreatorName,
          orderCreatorId:
            this.turnType === '2' ? this.userInfo.userCode : detailData.orderCreatorId,
          customerTransportRequire: detailData.customerTransportRequire,
          totalQty: detailData.totalQty,
          totalQtyUnit: detailData.totalQtyUnit,
          totalRoughWeight: detailData.totalRoughWeight,
          totalRoughWeightUnit: detailData.totalRoughWeightUnit,
          totalNetWeight: detailData.totalNetWeight,
          totalNetWeightUnit: detailData.totalNetWeightUnit,
          totalVolume: detailData.totalVolume,
          totalVolumeUnit: detailData.totalVolumeUnit,
          isTrucksTransport: detailData.isTrucksTransport === 1 ? true : false,
          companyCode: detailData.companyCode,
          companyName: detailData.companyName,
          containerTypeNum: JSON.parse(detailData.containerTypeNum),
          //附件需要特殊展示
          lopOrderCode: detailData.lopOrderCode,
        };
        this.baseDataDetailInfo = baseDataDetailInfo;
      },
      // 处理结算信息
      getSettlementInfoData(detailData) {
        const settlementInfo = {
          payTypeName: detailData.payTypeName || '',
          reconciliateRule: detailData.reconciliateRule || '',
          reconciliatePeriod: detailData.reconciliatePeriod === 1 ? '三月结' : '每月结',
          reconciliateDate: detailData.reconciliateDat
            ? `每月${detailData.reconciliateDate}日对账`
            : '',
          overdueAccountPeriod: detailData.overdueAccountPeriod
            ? `开票后${detailData.overdueAccountPeriod}日`
            : '',
        };
        this.settlementInfo = settlementInfo;
      },
      // 可视化信息
      getViewInfo(detailData) {
        const arr = [...detailData.ordinaryTruckInstructs, ...detailData.transportInstructs];
        const targetArr = [];
        if (arr.length > 0) {
          arr.forEach((item) => {
            targetArr.push({
              serviceName: this.transferSelect(item.serviceType, this.serviceList),
              serviceStatus: this.transferSelect(item.instructStatus, this.instructStatusList),
              startTime: item.instructIssueDate,
              completeTime: item.businessComplatedDate,
              isComplete: item.businessComplatedDate ? true : false,
            });
          });
        }
        this.infoArr = targetArr;
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // 处理产品与服务信息
      getProductInfo(detailData) {
        // transportInstructsInfo ordinaryTruckInstructsInfo
        const highwayInfoList = []; // 公路
        const railwayInfoList = []; // 铁路
        this.checkedRailList = [];
        this.checkedHighList = [];
        this.highwayTypeList = [];
        this.railwayTypeList = [];
        this.highwayLoading = [];
        this.consultArr = [];
        this.storageArr = [];
        this.superviseArr = [];
        this.highwayArr = [];
        this.collectArr = [];
        this.transAgencyArr = [];
        this.railwayLoadingArr = [];
        const transport = detailData.transportInstructs || []; // 其他运输
        const ordinary = detailData.ordinaryTruckInstructs || []; // 普通 集卡公路运输
        const tempArr = transport.concat(ordinary);
        console.log(tempArr, 'tempArr');
        tempArr.forEach((temp) => {
          if (temp.serviceType === '6' || temp.serviceType === '7') {
            this.checkedRailList.push(temp.serviceType);
            this.railwayTypeList.push(temp.serviceType);
            railwayInfoList.push(temp);
          } else {
            this.highwayTypeList.push(temp.serviceType);
            this.checkedHighList.push(temp.serviceType);
            highwayInfoList.push(temp);
          }
        });
        console.log(this.railwayTypeList, this.highwayTypeList, 'highwayInfoList');
        highwayInfoList.forEach((highway) => {
          // 普通公路运输
          if (highway.serviceType === '0') {
            // this.highwayArr = [];
            if (new Date() < new Date(highway.planDeliveryDate)) {
              highway.isOverdue = '未超期';
            } else {
              highway.isOverdue = '已超期';
            }
            this.highCurrStatus = highway.instructStatus;
            this.highwayArr.push(highway);
          } else if (highway.serviceType === '1') {
            // 集卡运输
            // this.collectArr = [];
            if (new Date() < new Date(highway.planDeliveryDate)) {
              highway.isOverdue = '未超期';
            } else {
              highway.isOverdue = '已超期';
            }
            this.jikaCurrStatus = highway.instructStatus;
            this.collectArr.push(highway);
          } else if (highway.serviceType === '2') {
            // 公路装卸服务
            console.log(highway, 'highwayLoadinghighwayLoading');
            this.highwayLoading.push(highway);
          } else if (highway.serviceType === '3') {
            // 咨询服务
            console.log(highway, 'consultArrconsultArr');
            this.consultArr.push(highway);
          } else if (highway.serviceType === '4') {
            // 仓储服务
            this.storageArr.push(highway);
          } else if (highway.serviceType === '5') {
            // 监管服务
            this.superviseArr.push(highway);
          }
        });
        railwayInfoList.forEach((railway) => {
          if (railway.serviceType === '7') {
            this.railwayLoadingArr.push(railway);
          } else if (railway.serviceType === '6') {
            this.transAgencyArr.push(railway);
          }
        });
      },
      // 保存
      save(operate, refreshFlag = false) {
        // 判断合同在的服务类型与已选择的服务类型是否一致
        const checkedList = [...this.checkedHighList, ...this.checkedRailList];
        console.log(checkedList, 'checkedList');

        const contractList = [...this.contractHighway, ...this.contractRailWay];
        if (JSON.stringify(checkedList.sort()) !== JSON.stringify(contractList.sort())) {
          this.$confirm(`选择的产品与服务，与合同未保持一致，订单是否继续？`, '提醒', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.checkedSave(operate, refreshFlag);
          });
        } else {
          this.checkedSave(operate, refreshFlag);
        }
      },
      checkedSave(operate, refreshFlag = false) {
        const baseDataRef = this.$refs.baseDataRef;
        baseDataRef.$refs.baseDataForm.validate((valid) => {
          if (valid) {
            console.log(this.$refs.baseDataRef.baseData, 'save');
            const saveParams = this.$refs.baseDataRef.baseData; // 基本信息
            if (Array.isArray(saveParams.customerNo) && saveParams.customerNo.length > 0) {
              const customerObj = saveParams.customerNo[0];
              saveParams.customerNo = customerObj.partnerCode;
              saveParams.customerName = customerObj.partnerZhName;
            }
            // saveParams.orderCreateDate = saveParams.orderCreateDate.getTime();
            const boxList = this.$refs.baseDataRef.boxList; // 箱型箱量
            // 勾选了集卡运输
            if (saveParams.isTrucksTransport) {
              boxList.map((box) => {
                if (!box.type || !box.number) {
                  return this.$message({
                    showClose: true,
                    message: '请添加箱型箱量',
                    type: 'error',
                  });
                }
              });
            }
            // fixbug-2048
            // if (boxList.length > 0 && saveParams.isTrucksTransport) {
            //   saveParams.containerTypeNum = JSON.stringify(boxList);
            // }
            if (boxList.length > 0) {
              saveParams.containerTypeNum = JSON.stringify(boxList);
            }
            this.storageAttachment = this.$refs.fileTableRef.getTableData();
            saveParams.attachments = this.storageAttachment;
            saveParams.operationFlag = operate ? operate : 0; // 保存标志
            saveParams.isTrucksTransport = saveParams.isTrucksTransport ? 1 : 0;
            saveParams.departmentCode = this.userInfo.departmentCode;
            saveParams.departmentName = this.userInfo.departmentName;
            let ordinaryTruckInstructs = [];
            let transportInstructs = [];
            if (this.checkedHighList.includes('0')) {
              // 已有普通公路运输 ordinaryTruckInstructs
              const generalData = this.$refs.transTable.generalData || [];
              if (generalData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写普通公路运输服务',
                  type: 'warning',
                });
              }
              generalData.forEach((item, index) => {
                item.serviceType = '0';
                item.sortNo = index;
                if (item.isOverdue) {
                  delete item.isOverdue;
                }
              });
              ordinaryTruckInstructs = ordinaryTruckInstructs.concat(generalData);
            }
            if (this.checkedHighList.includes('1')) {
              // 已有集卡运输服务 ordinaryTruckInstructs
              const truckData = this.$refs.truckTable.truckData || [];
              if (truckData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写集卡运输服务',
                  type: 'warning',
                });
              }
              truckData.forEach((item, index) => {
                item.serviceType = '1';
                item.sortNo = index;
                if (item.isOverdue) {
                  delete item.isOverdue;
                }
              });
              ordinaryTruckInstructs = ordinaryTruckInstructs.concat(truckData);
            }
            if (ordinaryTruckInstructs.length > 0) {
              saveParams.ordinaryTruckInstructs = ordinaryTruckInstructs;
            }
            // 已有公路装卸服务
            if (this.checkedHighList.includes('2')) {
              const commonFormData = this.$refs.handlingService.commonFormData || {};
              if (!commonFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写公路装卸服务',
                  type: 'warning',
                });
              }
              commonFormData.serviceType = '2';
              transportInstructs.push(commonFormData);
            }
            // 已有咨询服务
            if (this.checkedHighList.includes('3')) {
              const commonFormData = this.$refs.consultingService.commonFormData || {};
              if (!commonFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写咨询服务',
                  type: 'warning',
                });
              }
              commonFormData.serviceType = '3';
              transportInstructs.push(commonFormData);
            }
            // 已有仓储服务信息
            if (this.checkedHighList.includes('4')) {
              const commonFormData = this.$refs.warehousingService.commonFormData || {};
              if (!commonFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写仓储服务',
                  type: 'warning',
                });
              }
              commonFormData.serviceType = '4';
              transportInstructs.push(commonFormData);
            }
            // 已有监管服务信息
            if (this.checkedHighList.includes('5')) {
              const commonFormData = this.$refs.superviseService.commonFormData || {};
              if (!commonFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写监管服务',
                  type: 'warning',
                });
              }
              commonFormData.serviceType = '5';
              transportInstructs.push(commonFormData);
            }
            // 已有铁路运输代理服务
            if (this.checkedRailList.includes('6')) {
              const agencyServiceForm = this.$refs.agencyService.agencyServiceForm || {};
              if (
                !agencyServiceForm.serviceProviderCode ||
                !agencyServiceForm.roughWeight ||
                !agencyServiceForm.roughWeightUnit ||
                !agencyServiceForm.departurePlaceName ||
                !agencyServiceForm.departureProvinceCode ||
                !agencyServiceForm.destinationName ||
                !agencyServiceForm.destinationProvinceCode
              ) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路运输代理服务',
                  type: 'warning',
                });
              }
              const agencyTableData = this.$refs.agencyService.tableData || [];
              if (agencyTableData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路运输代理服务',
                  type: 'warning',
                });
              }
              let agencyObj = {};
              Object.assign(agencyObj, agencyServiceForm);
              agencyObj.serviceType = '6';
              agencyObj.truckContainers = agencyTableData;
              transportInstructs.push(agencyObj);
            }
            // 已有铁路装卸信息
            if (this.checkedRailList.includes('7')) {
              const commonFormData = this.$refs.dockService.commonFormData || {};
              if (!commonFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路装卸服务',
                  type: 'warning',
                });
              }
              commonFormData.serviceType = '7';
              transportInstructs.push(commonFormData);
            }
            // if (transportInstructs.length > 0) {
            //   saveParams.transportInstructs = transportInstructs;
            // }
            if (transportInstructs.length > 0) {
              const list = this.detailTransportInstructs || [];
              if (list.length > 0) {
                transportInstructs.map((item) => {
                  list.map((li) => {
                    if (li.serviceType === item.serviceType) {
                      item = Object.assign(li, item);
                    }
                  });
                });
              }
            }
            saveParams.transportInstructs = transportInstructs;
            // 获取 serviceType 和 productType
            const productTypeList = [];
            const serviceTypeList = this.checkedHighList.concat(this.checkedRailList);
            if (serviceTypeList.length > 0) {
              if (serviceTypeList.includes('6') || serviceTypeList.includes('7')) {
                productTypeList.push('1');
              }
              if (
                serviceTypeList.includes('0') ||
                serviceTypeList.includes('1') ||
                serviceTypeList.includes('2') ||
                serviceTypeList.includes('3') ||
                serviceTypeList.includes('4') ||
                serviceTypeList.includes('5')
              ) {
                productTypeList.push('0');
              }
            }
            saveParams.productType = productTypeList.toString();
            saveParams.serviceType = serviceTypeList.toString();
            if (this.orderId && this.turnType === '1') {
              // 编辑
              saveParams.id = this.orderId;
              saveParams.orderCode = this.$route.query.orderCode;
              saveParams.orderStatus = this.detailOrderStatus;
            }
            // 复制
            if (this.turnType === '2') {
              saveParams.isCopy = this.isCopy;
              saveParams.orderCode = this.copyDetailCode ? this.copyDetailCode : this.detailCode;
              saveParams.id = this.copyDetailId ? this.copyDetailId : this.detailId;
            }
            this.loading.startLoading();
            this.$axios.post(API.ORDER_SAVE, saveParams).then((res) => {
              this.loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t(res.data.msg),
                });
                if (refreshFlag) {
                  this.refreshPath();
                } else {
                  this.returnPath();
                }
              }
            });
          }
        });
      },
      // 一键下发
      oneClickRelease() {
        this.save(2);
      },
      oneClickReleaseAndRefresh() {
        this.save(2, true);
      },
      // 取消
      cancel() {
        if (this.turnType === '3') {
          this.returnPath();
        } else {
          this.$confirm('是否取消该订单填写', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.returnPath();
          });
        }
      },
      // 已选择的公路服务
      handleCheckedHighway(checkedHighList) {
        if (checkedHighList.includes('1')) {
          this.$refs.baseDataRef.baseData.isTrucksTransport = true;
        } else {
          this.$refs.baseDataRef.baseData.isTrucksTransport = false;
        }
        this.checkedHighList = checkedHighList;
        console.log(checkedHighList, '选择服务');
      },
      // 已选择的铁路服务
      handleCheckedRailway(checkedRailList) {
        console.log(checkedRailList, 'checkedRailList');
        if (checkedRailList.includes('6')) {
          this.$refs.baseDataRef.baseData.isTrucksTransport = true;
        } else {
          this.$refs.baseDataRef.baseData.isTrucksTransport = false;
        }
        this.checkedRailList = checkedRailList;
      },
      // 下发
      issued(val) {
        const baseDataRef = this.$refs.baseDataRef;
        baseDataRef.$refs.baseDataForm.validate((valid) => {
          if (valid) {
            // 通过val判断下发服务
            const saveParams = this.$refs.baseDataRef.baseData; // 基本信息
            if (Array.isArray(saveParams.customerNo) && saveParams.customerNo.length > 0) {
              const customerObj = saveParams.customerNo[0];
              saveParams.customerNo = customerObj.partnerCode;
              saveParams.customerName = customerObj.partnerZhName;
            }
            // saveParams.orderCreateDate = saveParams.orderCreateDate.getTime();
            const boxList = this.$refs.baseDataRef.boxList; // 箱型箱量
            // 勾选了集卡运输
            if (saveParams.isTrucksTransport) {
              boxList.forEach((box) => {
                if (!box.type || !box.number) {
                  return this.$message({
                    showClose: true,
                    message: '请添加箱型箱量',
                    type: 'warning',
                  });
                }
              });
            }
            // fixbug-2048
            // if (boxList.length > 0 && saveParams.isTrucksTransport) {
            //   saveParams.containerTypeNum = JSON.stringify(boxList);
            // }
            if (boxList.length > 0) {
              saveParams.containerTypeNum = JSON.stringify(boxList);
            }
            this.storageAttachment = this.$refs.fileTableRef.getTableData();
            saveParams.attachments = this.storageAttachment;
            saveParams.operationFlag = 1; // 下发标志
            saveParams.isTrucksTransport = saveParams.isTrucksTransport ? 1 : 0;
            saveParams.departmentCode = this.userInfo.departmentCode;
            saveParams.departmentName = this.userInfo.departmentName;
            saveParams.issueInstructServiceType = val;
            // if (this.turnType === '0' || this.turnType === '2') {
            //   saveParams.issueInstructServiceType = val;
            // }

            let ordinaryTruckInstructs = [];
            let transportInstructs = [];
            if (this.checkedHighList.includes('0')) {
              const generalData = this.$refs.transTable.generalData || [];
              if (generalData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写普通公路运输服务',
                  type: 'warning',
                });
              }
              // const generalData = this.$refs.transTable.selectGeneralList || [];
              if (generalData.length > 0) {
                generalData.forEach((item, index) => {
                  item.serviceType = '0';
                  item.sortNo = index;
                  if (item.isOverdue) {
                    delete item.isOverdue;
                  }
                });
              }
              ordinaryTruckInstructs = ordinaryTruckInstructs.concat(generalData);
            }

            if (this.checkedHighList.includes('1')) {
              const truckData = this.$refs.truckTable.truckData || [];
              if (truckData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写集卡运输服务',
                  type: 'warning',
                });
              }
              // const truckData = this.$refs.truckTable.selectTrunkList || [];
              if (truckData.length > 0) {
                truckData.forEach((item, index) => {
                  item.serviceType = '1';
                  item.sortNo = index;
                  if (item.isOverdue) {
                    delete item.isOverdue;
                  }
                });
              }
              ordinaryTruckInstructs = ordinaryTruckInstructs.concat(truckData);
            }

            if (this.checkedHighList.includes('2')) {
              const handlingFormData = this.$refs.handlingService.commonFormData || {};
              if (!handlingFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写公路装卸服务',
                  type: 'warning',
                });
              }
              handlingFormData.serviceType = '2';
              transportInstructs.push(handlingFormData);
            }

            if (this.checkedHighList.includes('3')) {
              const consultFormData = this.$refs.consultingService.commonFormData || {};
              if (!consultFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写咨询服务',
                  type: 'warning',
                });
              }
              consultFormData.serviceType = '3';
              transportInstructs.push(consultFormData);
            }

            if (this.checkedHighList.includes('4')) {
              const warehousingFormData = this.$refs.warehousingService.commonFormData || {};
              if (!warehousingFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写仓储服务',
                  type: 'warning',
                });
              }
              warehousingFormData.serviceType = '4';
              transportInstructs.push(warehousingFormData);
            }

            if (this.checkedHighList.includes('5')) {
              const superviseFormData = this.$refs.superviseService.commonFormData || {};
              if (!superviseFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写监管服务',
                  type: 'warning',
                });
              }
              superviseFormData.serviceType = '5';
              transportInstructs.push(superviseFormData);
            }

            if (this.checkedRailList.includes('6')) {
              const agencyFormData = this.$refs.agencyService.agencyServiceForm || {};
              if (
                !agencyFormData.serviceProviderCode ||
                !agencyFormData.roughWeight ||
                !agencyFormData.roughWeightUnit ||
                !agencyFormData.departurePlaceName ||
                !agencyFormData.departureProvinceCode ||
                !agencyFormData.destinationName ||
                !agencyFormData.destinationProvinceCode
              ) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路运输代理服务',
                  type: 'warning',
                });
              }
              const agencyTableData = this.$refs.agencyService.tableData || [];
              if (agencyTableData.length === 0) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路运输代理服务',
                  type: 'warning',
                });
              }
              let agencyObj = {};
              Object.assign(agencyObj, agencyFormData);
              agencyObj.serviceType = '6';
              agencyObj.truckContainers = agencyTableData;
              transportInstructs.push(agencyObj);
            }
            if (this.checkedRailList.includes('7')) {
              const dockFormData = this.$refs.dockService.commonFormData || {};
              if (!dockFormData.serviceProviderCode) {
                return this.$message({
                  showClose: true,
                  message: '请填写铁路装卸服务',
                  type: 'warning',
                });
              }
              dockFormData.serviceType = '7';
              transportInstructs.push(dockFormData);
            }
            // if (val === '0') {
            //   const generalData = this.$refs.transTable.generalData || [];
            //   generalData.forEach((item, index) => {
            //     item.serviceType = '0';
            //     item.sortNo = index;
            //     if (item.isOverdue) {
            //       delete item.isOverdue;
            //     }
            //   });
            //   if (generalData.length === 0) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写普通公路运输服务',
            //       type: 'warning',
            //     });
            //   }
            //   ordinaryTruckInstructs = ordinaryTruckInstructs.concat(generalData);
            // } else if (val === '1') {
            //   const truckData = this.$refs.truckTable.truckData || [];
            //   truckData.forEach((item, index) => {
            //     item.serviceType = '1';
            //     item.sortNo = index;
            //     if (item.isOverdue) {
            //       delete item.isOverdue;
            //     }
            //   });
            //   if (truckData.length === 0) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写集卡运输服务',
            //       type: 'warning',
            //     });
            //   }
            //   ordinaryTruckInstructs = ordinaryTruckInstructs.concat(truckData);
            // } else if (val === '2') {
            //   const commonFormData = this.$refs.handlingService.commonFormData || {};
            //   commonFormData.serviceType = '2';
            //   if (!commonFormData.serviceProviderCode) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写公路装卸服务',
            //       type: 'warning',
            //     });
            //   }
            //   transportInstructs.push(commonFormData);
            // } else if (val === '3') {
            //   const commonFormData = this.$refs.consultingService.commonFormData || {};
            //   commonFormData.serviceType = '3';
            //   if (!commonFormData.serviceProviderCode) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写咨询服务',
            //       type: 'warning',
            //     });
            //   }
            //   transportInstructs.push(commonFormData);
            // } else if (val === '4') {
            //   const commonFormData = this.$refs.warehousingService.commonFormData || {};
            //   if (!commonFormData.serviceProviderCode) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写仓储服务',
            //       type: 'warning',
            //     });
            //   }
            //   commonFormData.serviceType = '4';
            //   transportInstructs.push(commonFormData);
            // } else if (val === '5') {
            //   const commonFormData = this.$refs.superviseService.commonFormData || {};
            //   if (!commonFormData.serviceProviderCode) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写监管服务',
            //       type: 'warning',
            //     });
            //   }
            //   commonFormData.serviceType = '5';
            //   transportInstructs.push(commonFormData);
            // } else if (val === '6') {
            //   const agencyServiceForm = this.$refs.agencyService.agencyServiceForm || {};
            //   if (
            //     !agencyServiceForm.serviceProviderCode ||
            //     !agencyServiceForm.roughWeight ||
            //     !agencyServiceForm.roughWeightUnit
            //   ) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写铁路运输代理服务',
            //       type: 'warning',
            //     });
            //   }
            //   const agencyTableData = this.$refs.agencyService.tableData || [];
            //   let agencyObj = {};
            //   Object.assign(agencyObj, agencyServiceForm);
            //   agencyObj.serviceType = '6';
            //   agencyObj.truckContainers = agencyTableData;
            //   transportInstructs.push(agencyObj);
            // } else if (val === '7') {
            //   const commonFormData = this.$refs.dockService.commonFormData || {};
            //   if (!commonFormData.serviceProviderCode) {
            //     return this.$message({
            //       showClose: true,
            //       message: '请填写铁路装卸服务',
            //       type: 'warning',
            //     });
            //   }
            //   commonFormData.serviceType = '7';
            //   transportInstructs.push(commonFormData);
            // }
            // 获取 serviceType 和 productType
            const productTypeList = [];
            const serviceTypeList = this.checkedHighList.concat(this.checkedRailList);
            if (serviceTypeList.length > 0) {
              if (serviceTypeList.includes('6') || serviceTypeList.includes('7')) {
                productTypeList.push('1');
              }
              if (
                serviceTypeList.includes('0') ||
                serviceTypeList.includes('1') ||
                serviceTypeList.includes('2') ||
                serviceTypeList.includes('3') ||
                serviceTypeList.includes('4') ||
                serviceTypeList.includes('5')
              ) {
                productTypeList.push('0');
              }
            }
            saveParams.productType = productTypeList.toString();
            saveParams.serviceType = serviceTypeList.toString();
            if (ordinaryTruckInstructs.length > 0) {
              saveParams.ordinaryTruckInstructs = ordinaryTruckInstructs;
            }
            if (transportInstructs.length > 0) {
              const list = this.detailTransportInstructs || [];
              if (list.length > 0) {
                transportInstructs.map((item) => {
                  list.map((li) => {
                    if (li.serviceType === item.serviceType) {
                      item = Object.assign(li, item);
                    }
                  });
                });
              }
            }
            console.log(transportInstructs, 'transportInstructs');
            saveParams.transportInstructs = transportInstructs;
            if (this.turnType === '0' && this.detailId && this.detailCode) {
              saveParams.id = this.detailId;
              saveParams.orderCode = this.detailCode;
            }
            if (this.orderId && this.turnType === '1') {
              // 编辑
              saveParams.id = this.orderId;
              saveParams.orderCode = this.$route.query.orderCode;
              // saveParams.transportInstructs = this.copyTransportInstructs
              //   ? this.copyTransportInstructs
              //   : this.detailTransportInstructs;
            }
            if (this.turnType === '2') {
              // 复制
              saveParams.isCopy = this.isCopy;
              Object.assign(saveParams, this.copyParams);
              // saveParams.transportInstructs = this.copyTransportInstructs
              //   ? this.copyTransportInstructs
              //   : this.detailTransportInstructs;
              if (this.isCopy === 1) {
                delete saveParams.id;
                delete saveParams.orderCode;
                delete saveParams.orderCompletedDate;
                saveParams.orderStatus = '';
                // 详情时去掉orderCompletedDate值
                if (ordinaryTruckInstructs.length > 0) {
                  ordinaryTruckInstructs.map((item) => {
                    delete item.id;
                    delete item.instructCode;
                    delete item.instructIssueDate;
                    delete item.instructStatus;
                    delete item.instructUpdateDate;
                    delete item.orderCode;
                    delete item.businessComplatedDate;
                    item.orderTrackings = [];
                  });
                }
                if (transportInstructs.length > 0) {
                  transportInstructs.map((item) => {
                    delete item.id;
                    delete item.instructCode;
                    delete item.instructIssueDate;
                    delete item.instructStatus;
                    delete item.instructUpdateDate;
                    delete item.orderCode;
                    delete item.businessComplatedDate;
                    if ((item.truckContainers || []).length > 0) {
                      item.truckContainers.map((truck) => {
                        delete truck.id;
                        delete truck.instructCode;
                        delete truck.transportDataId;
                      });
                    }
                  });
                }
              }
            }
            this.loading.startLoading();
            this.$axios.post(API.ORDER_SAVE, saveParams).then((res) => {
              this.loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t(res.data.msg),
                });
                // this.returnPath();
                this.isCopy = 0;
                this.copyDetailId = res.data.data.id;
                this.copyDetailCode = res.data.data.orderCode;
                this.copyTransportInstructs = res.data.data.transportInstructs || [];
                this.getOrderDetail(res.data.data.id);
              }
            });
          }
        });
      },
      // 基础信息中改变合同带出数据的事件
      contractChange(obj) {
        console.log(obj, '1111111111111111');
        if (
          obj.serviceTypeCode &&
          (this.turnType === '0' || this.turnType === '2' || this.turnType === '1')
        ) {
          const contractServiceArr = obj.serviceTypeCode.split(',');
          contractServiceArr.forEach((service) => {
            if (service === '6' || service === '7') {
              this.railwayTypeList.push(service);
              this.contractRailWay.push(service);
            } else {
              this.contractHighway.push(service);
              this.highwayTypeList.push(service);
            }
            // 选择  集卡运输服务和铁路代理服务 是否箱型运输”默认勾选上
            if (service === '1' || service === '6') {
              this.$refs.baseDataRef.baseData.isTrucksTransport = true;
            }
          });
          this.checkedHighList = this.contractHighway;
          this.checkedRailList = this.contractRailWay;
        }

        this.contractRelationInfo = obj;
      },
      refreshPath() {
        // 新增
        console.log('add');
        const query = {
          turnType: '0',
        };
        const path = {
          path: '/intermodality/orderPage',
          name: 'orderPage',
          meta: {
            keepAlive: false,
            title: '订单新增',
          },
          query,
        };
        this.$nextTick(() => {
          if (this.turnType != 0) {
            this.$router.push(path);
          } else {
            this.$router.go(0);
          }
        });
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/intermodality/order',
            name: 'orderList',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      settleDialogClose() {
        this.settleDialogVisible = false;
        this.dialogType = '';
        this.settleDialogTitle = '';
        this.dialogData = [];
      },
    },
  };
</script>

<style lang="scss" scoped></style>
